import React from 'react';
import { motion } from 'motion/react';

interface FadeContentProps {
  children: React.ReactNode;
  className?: string;
  delay?: number;
  duration?: number;
}

const FadeContent: React.FC<FadeContentProps> = ({ 
  children, 
  className = '', 
  delay = 0,
  duration = 0.6 
}) => {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ 
        duration,
        delay,
        ease: 'easeOut'
      }}
      viewport={{ once: true, margin: '-50px' }}
    >
      {children}
    </motion.div>
  );
};

export default FadeContent;